import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Frequently Asked Questions | ShipSkis',
  description:
    'Get quick answers to the most frequently asked questions about ShipSkis. ' +
    'Learn how it works, what you can ship, international guidelines, and more.',
  alternates: {
    canonical: 'https://www.shipskis.com/faq',
  },
}

export default metadata
